import { useApplicationContext } from '@css-xp/base';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import {
  FetchPartnerBillingAdminIdsQuery,
  FetchPartnerBillingAdminIdsQueryVariables,
} from '@css-xp/graphtypes/src/generated-types-new';
import { fetchPartnerBillingAdminIds } from '../queries/fetch-billing-admins-ans';

// This is only required for Customer Advocates
// As we are not able to generate SCT for them, CCP calls are not possible
// So we will fetch billing admins from ANS and pass it to the BillingAdminOptions
// Check BillingAdminOptions in packages/utils/partner-purchase-center_server/src/graph/partner-graph/billing/transaction-account/transaction-account-type-defs.ts
export const useGetBillingAdminIdsFromAns = () => {
  const { txaId } = useParams<{ txaId: string }>();
  const context = useApplicationContext();
  const isLoggedInUserCustomerAdvocate = context?.isCustomerAdvocate;

  const { data, loading, error } = useQuery<
    FetchPartnerBillingAdminIdsQuery,
    FetchPartnerBillingAdminIdsQueryVariables
  >(fetchPartnerBillingAdminIds, {
    variables: {
      id: txaId || '',
    },
    skip: !txaId || !isLoggedInUserCustomerAdvocate,
  });

  const billingAdminIds = (data?.transactionAccount?.partnerBillingAdminIds ?? []) as string[];

  return {
    isLoggedInUserCustomerAdvocate,
    billingAdminIds,
    areBillingAdminIdsBeingFetched: loading,
    didErrorHappenWhileFetchingBillingAdminIds: error,
  };
};
